// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"342":"31cda98d","1575":"b67f0ee5","6386":"99b32363","7591":"67775256","8626":"67775256"}[chunkId] + ".chunk.css";
};